function qas_Reducer(state = [], action) {
    switch (action.type) {
        case 'QA/SET':
            return action.qa;
        case 'QA/CLEAR':
            return null;
        default:
            return state;
    }
}

export default qas_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/qa.js